"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DividerContainer = exports.Divider = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _styledIs = _interopRequireDefault(require("styled-is"));
var _colors = _interopRequireDefault(require("../../styles/colors"));
var _spacing = _interopRequireDefault(require("../../styles/spacing"));
var _templateObject;
var DividerContainer = exports.DividerContainer = _styledComponents["default"].div.withConfig({
  displayName: "HBDividerstyles__DividerContainer",
  componentId: "sc-1xq5pcr-0"
})(["margin:", ";width:100%;"], function (props) {
  return props.margin;
});
var Divider = exports.Divider = _styledComponents["default"].div.withConfig({
  displayName: "HBDividerstyles__Divider",
  componentId: "sc-1xq5pcr-1"
})(["position:relative;border:none;border-bottom:1px;border-bottom-color:", ";border-bottom-style:solid;height:0;margin:0;display:block;width:100%;background:transparent;> *{position:absolute;background:", ";padding-top:1px;line-height:1;padding-right:", ";transform:translateY(-50%);}", ";"], function (props) {
  return props.color;
}, _colors["default"].white, _spacing["default"][4], (0, _styledIs["default"])('dashed')(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n        border-bottom-style: dashed;\n    "]))));
//# sourceMappingURL=HBDivider.styles.js.map